const Template = `⊕課名⊕


▲教授▲


★修課年度★


￡教了什麼￡
（課程大概內容。或是額外學會了什麼東西。）


◆上課方式◆
（投影片、團體討論、老師教學風格）


▼考試作業▼


￥其他￥
（是否注重出席率or嚴禁遲到？需要的基礎？）


＆誰適合修這門課＆


￠最後想說的話￠


`

export default Template;